<template src="./plotsPage.html"></template>

<script>
import pipe from '../../../../../components/pipe/pipe.vue';
import reportMixin from '../../../../../js/reportMixin';

export default {
    name: 'plots-page',
    props: ['currentSelectedTab', 'observations', 'headerInputs', 'sessionFields', 'headerOptionsAndValues', 'reportTitle'],
    components: {'pipe': pipe,},
    mixins: [reportMixin],
    data() {
        return {
        }
    },
    computed: {
        session() {
            return this.$store.state.SessionsModule.Session;
        },
        upstreamManhole() {
            let umh = this.sessionFields.find((field) => field.LabelText === 'Upstream MH' || field.LabelText === 'Start ID');

            if (umh) {
                return umh.Value;
            }

            return '';
        },
        downstreamManhole() {
            let dmh = this.sessionFields.find((field) => field.LabelText === 'Downstream MH' || field.LabelText === 'End ID');

            if (dmh) {
                return dmh.Value;
            }

            return '';
        },
    },
}

</script>
